import React from "react";
import { blogPosts } from "../data/blogData";

const Blog = () => {
  return (
    <section id="blog" className="bg-slate-950 pt-32 pb-28 text-slate-100 relative overflow-hidden bg-cyber-grid">
      <div className="container mx-auto px-4">
        <div className="w-full">
          <div className="mx-auto mb-16 max-w-xl text-center">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-indigo-500/10 border border-indigo-500/30 text-indigo-400 font-mono text-xs font-bold uppercase tracking-widest mb-4">
              ✍️ SOFTWARE ARCHITECTURE INSIGHTS
            </div>
            <h2 className="mb-4 text-3xl font-black text-white sm:text-4xl lg:text-5xl tracking-tight">
              Engineering Insights &amp; <span className="text-indigo-400">Publications</span>
            </h2>
            <p className="text-sm font-normal text-slate-400 leading-relaxed">
              Deep dives on full-stack architecture, clean code principles, AI agent systems, and microservices scalability.
            </p>
          </div>
        </div>

        <div className="flex flex-wrap -mx-4 justify-center">
          {blogPosts.map((post) => (
            <div key={post.id} className="w-full px-4 lg:w-1/2 xl:w-1/3 mb-10 flex">
              <div className="cyber-card group flex flex-col flex-grow overflow-hidden rounded-3xl p-6 transition-all duration-300">
                <div className="relative overflow-hidden rounded-2xl mb-6 bg-slate-900 border border-slate-800">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-48 object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute top-3 right-3 px-3 py-1 bg-slate-950/90 text-indigo-400 font-mono text-[10px] font-bold rounded-full border border-indigo-500/30">
                    {post.readTime}
                  </span>
                </div>
                
                <div className="flex flex-col flex-grow justify-between">
                  <div>
                    <span className="text-[10px] font-mono font-bold text-indigo-400 uppercase tracking-widest mb-2 block">
                      {post.date}
                    </span>
                    <h3 className="mb-3 text-lg font-black text-white group-hover:text-indigo-400 transition-colors font-mono">
                      {post.title}
                    </h3>
                    <p className="mb-6 text-xs text-slate-300 leading-relaxed">
                      {post.excerpt}
                    </p>
                  </div>

                  <div>
                    <a
                      href={post.link}
                      className="inline-flex items-center gap-2 rounded-xl bg-slate-950 border border-indigo-500/30 hover:bg-indigo-500 hover:text-white py-3 px-5 font-mono font-bold text-xs uppercase tracking-wider text-indigo-400 transition duration-300 shadow-md"
                    >
                      <span>Read Engineering Article</span>
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Blog;
